import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {Contact} from "../../model/contact";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";
import { CustomValidators } from 'src/app/model/custom-validators';

@Injectable({
  providedIn: 'root'
})
export class UserCoordsFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(user: Contact): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<string>({
        key: "lastname",
        label: 'Nom de l\'utilisateur',
        value: user?.lastname,
        type: 'text',
        required: true,
        order: 1
      }),
      new FieldDefinition<string>({
        key: "firstname",
        label: 'Prénom de l\'utilisateur',
        value: user?.firstname,
        type: 'text',
        required: true,
        order: 2
      }),
      new FieldDefinition<string>({
        key: 'email',
        label: 'Email de l\'utilisateur',
        value: user?.email,
        type: 'text',
        warn: 'Afin de centraliser au mieux les demandes d\'assistance, ' +
          'le mail doit être nominatif, aucun compte ne sera créé en cas de compte générique',
        required: true,
        validators: [CustomValidators.email()],
        order: 3
      }),
      new FieldDefinition<string>({
        key: 'phone',
        label: 'Numéro de téléphone de l\'utilisateur',
        value: user?.phone,
        type: 'text',
        required: true,
        validators: [CustomValidators.phone()],
        order: 4
      })
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
